import React, { Component } from "react";
import {
  Table,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableBody,
  TableRowColumn,
} from "material-ui/Table";
import { Dialog } from "material-ui";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import Tooltip from "rc-tooltip";
import ArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import ArrowUp from "material-ui/svg-icons/navigation/arrow-drop-up";
/*import ContentCopy from 'material-ui/svg-icons/content/content-copy';*/
import Setting from "material-ui/svg-icons/action/settings";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import FlatButton from "material-ui/FlatButton";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import Clear from "material-ui/svg-icons/content/clear";
import {
  splitNumber,
  audienceAnywhereLogoDataUri,
  imageDispalyUri,
  imageEmailUri,
  imageSocialUri,
  pdfReportFooterDataUri,
} from "../../../utils/utility";
import { Row, Col } from "../../framework/Grid/";

import SegmentSummary from "../Detail/SegmentSummary";
import NavList from "./NavList";
import moment from "moment";
import RadioButton from "material-ui/RadioButton";

import { apiBaseUrl } from "../../../env";
import { map, last } from "lodash";
import "rc-tooltip/assets/bootstrap_white.css";
import "./segmentlist.css";
// create campaign component
import CreateCampaign from "./CreateCampaign";

// page component
import Page from "../../framework/Page/Page";

import { buttonBlueColor } from "../../../utils/utility";

const pdfConverter = require("jspdf");
const html2canvas = require("html2canvas");

const styles = {
  tableHeaderStyle: {
    background: "#F5F5F5",
    borderTop: "0px solid #E8EBEF",
    borderBottom: "0px solid #E8EBEF",
  },
  arrowStyle: {
    position: "absolute",
    top: "10px",
  },
  tableHeaderColumn: {
    height: "50px",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bolder",
    paddingLeft: "10px",
    paddingRight: "10px",
    fontSize: "16px",
  },
  tableHeaderSortedColumn: {
    height: "50px",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bolder",
    background: "#E3E3E3",
    paddingLeft: "10px",
    paddingRight: "10px",
    backgroundClip: "padding-box",
    fontSize: "16px",
  },
  tableRowColumn: {
    position: "relative",
    paddingRight: "10px",
    paddingLeft: "10px",
    height: "50px",
    fontSize: "16px",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  tableCountRowColumn: {
    position: "relative",
    paddingRight: "10px",
    paddingLeft: "10px",
    fontSize: "16px",
  },
  settingStyle: {
    position: "absolute",
    right: "1.1em",
    top: "0.9em",
    cursor: "pointer",
  },
};
class SegmentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageCount: [1, 2, 3, 4, 5, 6],
      activeIndex: 1, //record pageNumber
      ifHasNextGroup: true, // next button display control, default has next group icon
      ifHasPreGroup: false, // previous button display control, default no previous group icon
      popout: false, // popout archive tips
      archivedId: "",
      openDetailDialog: false,
      detailSegmentId: 0,
      open: false, // if open dialog
      archive_data_obj: {}, // for copy segment
      openCreateCampaignDialog: false,
      ifShowEmailSubCheckbox: false, // when email checkbox is selected change the value to `true`
      ifSocialMediaChecked: false, // when `Social Media` checkbox is selected set value to `true`
      socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
      socialMediaGoogle: false, // when `the social media's selection google` checkbox is selected set value to `true`
      ifDisplayChecked: false, // when `Display Advertising` checkbox is selected set value to `true`
      createCampaign_segment_id: "",
      createCampaign_clientId: "", // the client id for create campaign component
      showLoadingDialog: false,
      showDataLoadingDialog: false,
      segmentsId: new Set([]), // set data for checkbox selected
    };
  }
  componentDidMount() {
    const width = document.getElementById("tbl-segments-list").clientWidth;
    this.setState({ width: width });

    // if pageCount less than six show pageCount length

    // console.log(this.props.data.pageCount)
    // if (this.props.data.pageCount <= this.state.pageCount.length) {
    //   let len = this.props.data.pageCount;
    //   let obj = [];
    //   for (let i = 0; i < len; i++) {
    //     obj.push(i + 1)
    //   }
    //   this.setState({
    //     pageCount: obj,
    //     ifHasNextGroup: false
    //   })
    // }
    if (this.props.save_segment_report_id) {
      this.showSegmentDetail(+this.props.save_segment_report_id);
    }
  }

  componentWillReceiveProps(nextProps) {
    let client_id = "";
    if (
      !nextProps.selectedSegmentSetArray ||
      nextProps.selectedSegmentSetArray.length === 0
    ) {
      // if selectedSegmentSetArray lenght is 0 clear state data
      if (this.props.flag !== "archive") {
        this.setState({
          segmentsId: new Set([]),
        });
      }
    }
    if (nextProps.ifCreateAudienceFile) {
      nextProps.data.data.map(item => {
        if (item.id === nextProps.selectedSegmentSetArray[0]) {
          client_id = item.clientId;
        }

        return false;
      });
      this.setState({
        openCreateCampaignDialog: true,
        createCampaign_segment_id: nextProps.selectedSegmentSetArray[0],
        createCampaign_clientId: client_id,
      });
    }
    let initPageCount = [1, 2, 3, 4, 5, 6];
    if (nextProps.data.pageCount <= initPageCount.length) {
      let len = nextProps.data.pageCount;
      let obj = [];
      for (let i = 0; i < len; i++) {
        obj.push(i + 1);
      }
      this.setState({
        pageCount: obj,
        ifHasNextGroup: false,
      });
    }
    // if (nextProps.data.pageCount > initPageCount.length) {
    //   this.setState({
    //     pageCount: [1,2,3,4,5,6],
    //     ifHasNextGroup: true
    //   })
    // }
    if (nextProps.ifArchiveSuccess) {
      this.setState({
        ifMaterialUIpopout: true,
      });
    }
    if (!isEmpty(nextProps.copy_segment)) {
      let rawData = JSON.parse(nextProps.copy_segment.rawData);
      nextProps.segment_edit_creation.selected_segments =
        rawData.selected_segments;
      nextProps.segment_edit_creation.plotted_values = rawData.plotted_values;
      nextProps.segment_edit_creation.selected_city = rawData.selected_city;
      nextProps.segment_edit_creation.selected_state = rawData.selected_state;
      nextProps.segment_edit_creation.selected_county = rawData.selected_county;
      nextProps.segment_edit_creation.selected_dma = rawData.selected_dma;

      nextProps.segment_edit_creation.zipcode = rawData.zipcode;
      nextProps.segment_edit_creation.segment_name = rawData.name;
      nextProps.copy_segment.rules.forEach(item => {
        nextProps.segment_edit_creation.rules_id.push({
          id: item.id,
          attributeId: item.attributeId,
        });
      });
      nextProps.segment_edit_creation.segment_id = nextProps.copy_segment.id;
    }
    // for active edit segment link
    if (!isEmpty(nextProps.active_segment_attributes)) {
      let rawData = JSON.parse(nextProps.active_segment_attributes.rawData);
      nextProps.segment_active_creation.selected_segments =
        rawData.selected_segments;
      nextProps.segment_active_creation.plotted_values = rawData.plotted_values;
      nextProps.segment_active_creation.selected_city = rawData.selected_city;
      nextProps.segment_active_creation.selected_state = rawData.selected_state;
      nextProps.segment_active_creation.selected_county =
        rawData.selected_county;
      nextProps.segment_active_creation.selected_dma = rawData.selected_dma;
      nextProps.segment_active_creation.zipcode = rawData.zipcode;
      nextProps.segment_active_creation.segment_name = rawData.name;
      nextProps.active_segment_attributes.rules.forEach(item => {
        nextProps.segment_active_creation.rules_id.push({
          id: item.id,
          attributeId: item.attributeId,
        });
      });
      nextProps.segment_active_creation.segment_id =
        nextProps.active_segment_attributes.id;
    }
  }
  initPageArray(obj) {
    if (obj.data.pageCount <= this.state.pageCount.length) {
      let len = obj.data.pageCount;
      let _obj = [];
      for (let i = 0; i < len; i++) {
        _obj.push(i + 1);
      }
      this.setState({
        pageCount: _obj,
        ifHasNextGroup: false,
      });
    }
  }
  handleClick(e) {
    this.props.headerBeClick(e.target.innerText, this.state.activeIndex);
  }
  handleClickPage(page) {
    this.props.pageBeClick(page);
    this.setState({
      activeIndex: page,
    });
  }
  goToNext(page) {
    // if activeIndex greater than total return
    this.props.nextBeClick(page);
    this.setState({
      activeIndex: page,
    });
  }
  nextToGroup(page) {
    this.props.nextGroupBeClick(page);
  }
  previousToGroup(page) {
    this.props.previousGroupBeClick(page);
  }
  goToPrevious(page) {
    this.props.previousBeClick(page);
  }
  selectRows(page, row) {
    this.props.selectRows(page, row);
  }

  goToPage(page) {
    this.props.goToPage(page);
  }
  popoutTip(e) {
    this.setState({
      popout: true,
    });
  }
  // archive segment function
  handleConfirmArchive(id) {
    this.setState({
      archivedId: id,
    });
    this.props.archiveSegment(id);
    this.setState({
      popout: false,
    });
    window.setTimeout(() => {
      this.setState(
        {
          archivedId: "",
        },
        () => {
          this.props.updateSegmentList(this.state.activeIndex); // update segment list when archive success
        },
      );
    }, 3000);
  }
  handleCancelArchive(e) {
    this.setState({
      popout: false,
    });
  }
  onVisibleChange(visible) {
    this.setState({
      popout: false,
    });
  }

  copySegment(id) {
    const segmentObj = this.props.data.data.find(x => x.id === id);
    this.setState({
      open: true,
      archive_data_obj: segmentObj,
    });
    this.props.getAttributes(id);
  }
  handleCopyToCreate(e, id, clientId, name) {
    // get user selected attributes
    e.stopPropagation();
    this.setState({ showDataLoadingDialog: true });
    this.props.selectedClientChanged(clientId);
    this.props.copySegmentRedirect(id);
  }
  handleClose = () => {
    this.setState({ open: false });
  };
  handleActiveRedirectCreate(id, clientId) {
    this.setState({ showDataLoadingDialog: true, openDetailDialog: false });
    this.props.handleActiveRedirectCreate(id, clientId);
  }

  closeSegmentDetailDialog() {
    this.props.clearSegmentSummary();
    this.setState({
      openDetailDialog: false,
      detailSegmentId: 0,
      segment_summary: null,
    });
  }

  closeCreateCampaignDialog() {
    this.setState({
      openCreateCampaignDialog: false,
      ifSocialMediaChecked: false,
      ifDisplayChecked: false,
      socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
      socialMediaGoogle: false,
    });
    // rollback ifRequestSuccess value
    this.props.rollbackRequestSuccessToFalse(false);
    this.props.closeCreateCampaignDialog();
  }
  handleEmailChecked(e, isInputChecked) {
    // if (!isInputChecked) {
    //   this.setState({
    //     ifReturnEmailChecked: isInputChecked
    //   })
    // }
  }
  handleReturnEmail(e, isInputChecked) {
    // this.setState({
    //   ifReturnEmailChecked: isInputChecked
    // })
  }
  handleSocialMedia(e, isInputChecked) {
    this.setState({
      ifSocialMediaChecked: isInputChecked,
    });
    if (!isInputChecked) {
      this.setState({
        socialMediaFacebook: false,
        socialMediaGoogle: false,
      });
    } else {
      this.setState({
        socialMediaFacebook: true,
        socialMediaGoogle: true,
      });
    }
  }
  // handleSocialMediaAllChecked() {
  //   this.setState({
  //     socialMediaFacebook: true,
  //     socialMediaGoogle: true
  //   })
  // }
  handleFacebookCheck(e, isInputChecked) {
    this.setState({
      socialMediaFacebook: isInputChecked,
    });
  }
  handleGoogleCheck(e, isInputChecked) {
    this.setState({
      socialMediaGoogle: isInputChecked,
    });
  }
  handleDisplayCheck(e, isInputChecked) {
    this.setState({
      ifDisplayChecked: isInputChecked,
    });
  }
  // handleSelectAllCheckbox() {
  //   this.setState({
  //     ifShowEmailSubCheckbox: true,
  //     ifSocialMediaChecked: true,
  //     ifDisplayChecked: true
  //   })
  // }
  _addSummarytoPDF(segment, attributes, pdf) {
    let top = 10;

    pdf.setFont("helvetica");
    pdf.setFontSize(22);
    pdf.addImage(audienceAnywhereLogoDataUri(), "png", 12, top);
    top += 30;
    pdf.setFontSize(12);
    pdf.setFontType("bold");
    pdf.text(12, top, "Audience Segment Name: ");
    pdf.setFontType("normal");
    pdf.text(67, top, segment.name);
    top += 10;

    const line_len = 26;
    pdf.setFont("helvetica");
    pdf.setFontType("normal");
    pdf.setFontSize(10);

    let strDate =
      "Date%%% " + moment(segment.createdTime, "x").format("MMMM D, YYYY");
    const fillStrWidth = pdf.getStringUnitWidth(" _");

    const arrReplace = [];
    //for (let i = 0; i < (line_len - strDate.length) / 2; i++) {
    for (
      let i = 0;
      i < (line_len - pdf.getStringUnitWidth(strDate) - 3) / fillStrWidth;
      i++
    ) {
      arrReplace.push(" _");
    }
    strDate = strDate.replace("%%%", arrReplace.join(""));
    arrReplace.length = 0;

    let strAttributes = "Attributes%%% " + attributes;
    //for (let i = 0; i < (line_len - strAttributes.length) / 2; i++) {
    for (
      let i = 0;
      i < (line_len - pdf.getStringUnitWidth(strAttributes) - 3) / fillStrWidth;
      i++
    ) {
      arrReplace.push(" _");
    }
    strAttributes = strAttributes.replace("%%%", arrReplace.join(""));

    let strClient = "Client%%% " + segment.clientName;
    arrReplace.length = 0;
    //for (let i = 0; i < (line_len - strClient.length) / 2; i++) {
    for (
      let i = 0;
      i < (line_len - pdf.getStringUnitWidth(strClient) - 3) / fillStrWidth;
      i++
    ) {
      arrReplace.push(" _");
    }
    strClient = strClient.replace("%%%", arrReplace.join(""));

    let strAudience = "Audience%%% " + splitNumber(segment.count + "")();
    arrReplace.length = 0;
    //		for (let i = 0; i < (line_len - strAudience.length) / 2; i++) {
    for (
      let i = 0;
      i < (line_len - pdf.getStringUnitWidth(strAudience) - 3) / fillStrWidth;
      i++
    ) {
      arrReplace.push(" _");
    }
    strAudience = strAudience.replace("%%%", arrReplace.join(""));

    pdf.setFontSize(10);
    pdf.text(16, top, strDate);
    pdf.text(190, top, strAttributes, null, null, "right");
    top += 12;
    pdf.text(16, top, strClient);
    //pdf.text(190, top, strAudience, null, null, "right")
    top += 10;
    pdf.setDrawColor(169, 169, 169);
    pdf.line(12, top, 200, top);
    top += 6;
    pdf.setDrawColor(255, 255, 255);
    pdf.text(16, top, "Audience: " + splitNumber(segment.count + "")());
    pdf.text(88, top, "Reach By Channel");
    pdf.addImage(imageEmailUri(), "PNG", 120, top - 3, 4, 4);
    pdf.text(125, top, splitNumber(segment.email + "")());
    pdf.addImage(imageSocialUri(), "PNG", 146, top - 3, 4, 4);
    pdf.text(151, top, splitNumber(segment.social + "")());
    pdf.addImage(imageDispalyUri(), "PNG", 174, top - 3, 4, 4);
    pdf.text(179, top, splitNumber(segment.display + "")());

    top += 4;
    pdf.setDrawColor(169, 169, 169);
    pdf.line(12, top, 200, top);
    top += 12;
    pdf.setDrawColor(255, 255, 255);

    pdf.setFontType("bold");
    let strTableHead = "ATTRIBUTE%%%COUNT";
    arrReplace.length = 0;
    for (let i = 0; i < 96 + 56 - strTableHead.length - 3; i++) {
      arrReplace.push(" ");
    }
    pdf.text(16, top, strTableHead.replace("%%%", arrReplace.join("")));
    top += 5;
    pdf.setDrawColor(169, 169, 169);
    pdf.line(12, top, 200, top);
    return top;
  }

  _handleDownloadListPDF(segment, attributes, demoAttributes, geoAttributes) {
    const datas = this._generateSelectData(segment);
    const geoDatas = this._generateGeographyData(segment);
    const rawData = JSON.parse(segment.rawData);
    const pdf = new pdfConverter("p", "mm", "a4");
    this.setState({ loaded: false });

    pdf.setFont("helvetica");
    pdf.setFontType("normal");
    pdf.setFontSize(9);
    let top = 10;

    top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
    let imageRendering = false;
    const fileName = segment.name + "_list_report.pdf";

    setTimeout(
      function() {
        if (!isEmpty(datas)) {
          pdf.setFontSize(10);
          pdf.setFontType("normal");
          pdf.text(18, top, "");
          top += 8;
        }
        map(datas, (data, key) => {
          pdf.setFontType("normal");
          pdf.setFontSize(9);
          const arrReplace = [];
          const fillStrWidth = pdf.getStringUnitWidth(" _");

          for (
            var i = 0;
            i < (48 - pdf.getStringUnitWidth(data.label)) / fillStrWidth;
            i++
          ) {
            arrReplace.push(" _");
          }

          pdf.text(
            190,
            top,
            data.label + arrReplace.join(""),
            null,
            null,
            "right",
          );
          top += 8;
          if (top > 260) {
            pdf.addPage("a4", "p");
            top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
          }
          map(data, (dataVal, dataKey) => {
            if (dataKey !== "label" && dataKey !== "total") {
              arrReplace.length = 0;
              const valStr = dataVal.label + splitNumber(dataVal.total)();
              for (
                var i = 0;
                i < (24 - pdf.getStringUnitWidth(valStr)) / fillStrWidth;
                i++
              ) {
                arrReplace.push(" _");
              }
              pdf.text(
                185,
                top,
                dataVal.label +
                  arrReplace.join("") +
                  splitNumber(dataVal.total)(),
                null,
                null,
                "right",
              );
              top += 5;
            }
          });
          pdf.setDrawColor(128, 128, 128);
          pdf.line(98, top, 188, top);
          top += 5;
          if (top > 260) {
            pdf.addPage("a4", "p");
            top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
          }
          pdf.setFontType("bold");
          pdf.setFontSize(12);
          pdf.text(185, top, splitNumber(data.total)(), null, null, "right");
          top += 8;
          if (top > 260) {
            pdf.addPage("a4", "p");
            top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
          }
        });
        const els = document.getElementsByClassName("geo-map-row-container");

        if (els.length > 0) {
          const el = els[0].firstElementChild;
          imageRendering = true;
          if (!isEmpty(datas)) {
            pdf.addPage("a4", "p");
            top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
          }
          pdf.setFontSize(10);
          pdf.setFontType("normal");
          pdf.text(18, top, "GEOGRAPHY");
          top += 5;
          html2canvas(el, {
            proxy: `${apiBaseUrl}/proxy/images`,
            useCORS: true,
            allowTraint: true,
          }).then(
            function(canvas) {
              pdf.addImage(canvas.toDataURL(), "PNG", 18, 90, 174, 0);

              setTimeout(
                function() {
                  this.setState({ loaded: true });
                  var pageCount = pdf.internal.getNumberOfPages();
                  pdf.setFontSize(8);
                  pdf.setFontType("normal");

                  for (var i = 0; i < pageCount; i++) {
                    pdf.setPage(i);
                    pdf.text(
                      188,
                      288,
                      "Page " +
                        pdf.internal.getCurrentPageInfo().pageNumber +
                        " of " +
                        pageCount,
                      null,
                      null,
                      "right",
                    );
                    pdf.addImage(
                      pdfReportFooterDataUri(),
                      "PNG",
                      15,
                      290,
                      20,
                      0,
                    );
                    pdf.text(
                      65,
                      288,
                      "© " +
                        moment().format("YYYY") +
                        " Claritas, LLC. All rights reserved",
                    );
                  }
                  pdf.save(fileName);
                  this.setState({ showLoadingDialog: false });
                }.bind(this),
                5000,
              );
            }.bind(this),
          );

          top += 70;
          pdf.setDrawColor(128, 128, 128);
          pdf.line(18, top, 190, top);
          top += 5;
          pdf.text(18, top, "GEOGRAPHIC AREA SELECTED");
          const rawData = JSON.parse(segment.rawData);
          pdf.text(
            186,
            top,
            splitNumber(rawData.plotted_values.audienceCount.total)(),
            null,
            null,
            "right",
          );
        }
        if (
          rawData.selected_state.length +
            rawData.selected_city.length +
            rawData.zipcode.length +
            rawData.selected_county.length +
            rawData.selected_dma.length +
            geoDatas.length >
          0
        ) {
          if (!isEmpty(datas)) {
            pdf.addPage("a4", "p");
            top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
          }
          pdf.setFontSize(10);
          pdf.setFontType("normal");
          pdf.text(18, top, "GEOGRAPHY");
          top += 8;
          if (rawData.selected_state.length > 0) {
            const arrReplace = [];
            const fillStrWidth = pdf.getStringUnitWidth(" _");

            for (
              var i = 0;
              i < (48 - pdf.getStringUnitWidth("State")) / fillStrWidth;
              i++
            ) {
              arrReplace.push(" _");
            }

            pdf.text(
              190,
              top,
              "State" + arrReplace.join(""),
              null,
              null,
              "right",
            );
            top += 8;
            map(rawData.selected_state, state => {
              arrReplace.length = 0;

              const valStr = state.label + splitNumber(state.total)();
              for (
                var i = 0;
                i < (24 - pdf.getStringUnitWidth(valStr)) / fillStrWidth;
                i++
              ) {
                arrReplace.push(" _");
              }
              pdf.text(
                185,
                top,
                state.label + arrReplace.join("") + splitNumber(state.total)(),
                null,
                null,
                "right",
              );
              top += 5;
            });
          }
          if (rawData.selected_city.length > 0) {
            const arrReplace = [];
            const fillStrWidth = pdf.getStringUnitWidth(" _");

            for (
              i = 0;
              i < (48 - pdf.getStringUnitWidth("City")) / fillStrWidth;
              i++
            ) {
              arrReplace.push(" _");
            }

            pdf.text(
              190,
              top,
              "City" + arrReplace.join(""),
              null,
              null,
              "right",
            );
            top += 8;
            map(rawData.selected_city, city => {
              arrReplace.length = 0;

              const valStr =
                city.value + ", " + city.state + splitNumber(city.total)();
              for (
                var i = 0;
                i < (24 - pdf.getStringUnitWidth(valStr)) / fillStrWidth;
                i++
              ) {
                arrReplace.push(" _");
              }
              pdf.text(
                185,
                top,
                city.value +
                  ", " +
                  city.state +
                  arrReplace.join("") +
                  splitNumber(city.total)(),
                null,
                null,
                "right",
              );
              top += 5;
            });
          }
          if (geoDatas.length > 0) {
            const arrReplace = [];
            arrReplace.length = 0;
            const fillStrWidth = pdf.getStringUnitWidth(" _");

            let valStr = geoDatas[0] + splitNumber(segment.count)();
            for (
              i = 0;
              i < (47 - pdf.getStringUnitWidth(valStr)) / fillStrWidth;
              i++
            ) {
              arrReplace.push(" _");
            }

            pdf.text(
              185,
              top,
              geoDatas[0] + arrReplace.join("") + splitNumber(segment.count)(),
              null,
              null,
              "right",
            );
            top += 7;

            valStr = geoDatas[1] + geoDatas[2];
            arrReplace.length = 0;
            for (
              i = 0;
              i < (47 - pdf.getStringUnitWidth(valStr)) / fillStrWidth;
              i++
            ) {
              arrReplace.push(" _");
            }
            pdf.text(
              185,
              top,
              geoDatas[1] + arrReplace.join("") + geoDatas[2],
              null,
              null,
              "right",
            );
            top += 5;
          }
        }

        if (!imageRendering) {
          setTimeout(
            function() {
              var pageCount = pdf.internal.getNumberOfPages();
              pdf.setFontSize(8);
              pdf.setFontType("normal");

              for (var i = 0; i < pageCount; i++) {
                pdf.setPage(i);
                pdf.text(
                  188,
                  288,
                  "Page " +
                    pdf.internal.getCurrentPageInfo().pageNumber +
                    " of " +
                    pageCount,
                  null,
                  null,
                  "right",
                );
                pdf.addImage(pdfReportFooterDataUri(), "PNG", 15, 290, 20, 0);

                pdf.text(
                  65,
                  288,
                  "© " +
                    moment().format("YYYY") +
                    " Claritas, LLC. All rights reserved",
                );
              }
              this.setState({ loaded: true });
              pdf.save(fileName);
              this.setState({ showLoadingDialog: false });
            }.bind(this),
            6000,
          );
        }
      }.bind(this),
      1000,
    );
  }

  handleEdit(id) {
    const { getSegmentWithRules, selectedClientChanged, data } = this.props;
    this.setState({
      segmentIds: new Set([]),
    });
    let cid = undefined;
    data.data.forEach(item => {
      if (item.id === id) {
        selectedClientChanged(item.clientId);
        cid = item.clientId;
      }
    });

    getSegmentWithRules(id, cid);
    this.props.clearSegmentSummary();
  }

  _handleDownloadPDF(segment, attributes, demoAttributes, geoAttributes) {
    const els = document.getElementsByClassName("icon-pie-chart4");
    if (this.state.showLoadingDialog === true) return;
    this.setState({ showLoadingDialog: true });
    if ((" " + els[0].className + " ").indexOf("active") > -1) {
      this._handleDownloadChartPDF(
        segment,
        attributes,
        demoAttributes,
        geoAttributes,
      );
    } else {
      this._handleDownloadListPDF(
        segment,
        attributes,
        demoAttributes,
        geoAttributes,
      );
    }
  }

  _handleDownloadChartPDF(segment, attributes, demoAttributes, geoAttributes) {
    const geoDatas = this._generateGeographyData(segment);
    const pdf = new pdfConverter("p", "mm", "a4");
    this.setState({ loaded: false });
    //const el = document.getElementById("segment-summary-container")
    /*
		html2canvas(el, {
			onrendered: function (canvas) {
				//pdf.addImage(canvas.toDataURL(), 'PNG', -50, -15, 0, 0, 'IMG1', 'fast')
				//pdf.fromHTML(canvas, 10, 10, { 'width': 180 })
				//pdf.save('test.pdf')
				document.body.appendChild(canvas)
			}, allowTraint: true, useCROS: true, type: "view"
		});*/
    pdf.setFont("helvetica");
    pdf.setFontType("normal");
    pdf.setFontSize(9);
    //pdf.text(195, 278, "Page 1 of 1", null, null, "right")
    //pdf.text(12, 288, "©" + moment().format("YYYY") + " Claritas, LLC. All rights reserved")
    const els = document.getElementsByClassName("segment-attr-panel");

    let top = 10;
    const pdfCanvas = [];
    //document.querySelectorAll('.segment-attr-panel').forEach((el) => {
    const isIndChartReady = [];
    map(els, el => {
      const width = el.offsetWidth;
      el.style.width = "700px";
      isIndChartReady.push(false);
      setTimeout(function() {
        html2canvas(el).then(function(canva) {
          pdfCanvas.push(canva);
          isIndChartReady.pop();
        });
      }, 50);
      setTimeout(function() {
        el.style.width = width + "px";
      }, 100);
    });

    const cityStateZipcodeCanvas = [];
    const isCityStateChartReady = [];
    document.querySelectorAll(".city-state-panel").forEach(el => {
      isCityStateChartReady.push(false);
      const width = el.offsetWidth;
      el.style.width = "700px";
      setTimeout(function() {
        html2canvas(el).then(function(canva) {
          cityStateZipcodeCanvas.push(canva);
          isCityStateChartReady.pop();
        });
      }, 50);
      setTimeout(function() {
        el.style.width = width + "px";
      }, 50);
    });
    const isZipChartReady = [];
    document.querySelectorAll(".zipcode-panel").forEach(el => {
      isZipChartReady.push(false);
      const width = el.offsetWidth;
      el.style.width = "700px";
      setTimeout(function() {
        html2canvas(el).then(function(canva) {
          cityStateZipcodeCanvas.push(canva);
          isZipChartReady.pop();
        });
      }, 50);
      setTimeout(function() {
        el.style.width = width + "px";
      }, 50);
    });

    top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
    let newPage = false;
    let intervalId = setInterval(
      function() {
        if (
          isIndChartReady.length > 0 ||
          isCityStateChartReady.length > 0 ||
          isZipChartReady.length > 0
        ) {
          console.log("waiting...");
        } else {
          clearInterval(intervalId);
          setTimeout(
            function() {
              const fileName = segment.name + "_chart_report.pdf";
              if (pdfCanvas.length > 0) {
                newPage = true;
                pdf.setFontSize(10);
                pdf.setFontType("normal");
                pdf.text(16, top, "");
                top += 5;
                map(pdfCanvas, canvas => {
                  pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
                  pdf.setFillColor(255);
                  pdf.rect(196, top - 1, 10, (canvas.height / 240) * 67, "F");
                  top += (canvas.height / 240) * 70;
                  if (top > 208 && canvas !== last(pdfCanvas)) {
                    pdf.addPage("a4", "p");
                    top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
                  }
                });
              }
              if (cityStateZipcodeCanvas.length > 0) {
                if (newPage) {
                  pdf.addPage("a4", "p");
                  top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
                }
                newPage = true;
                pdf.setFontSize(10);
                pdf.setFontType("normal");
                pdf.text(16, top, "GEOGRAPHIC");
                top += 5;

                map(cityStateZipcodeCanvas, canvas => {
                  pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
                  pdf.setFillColor(255);
                  pdf.rect(196, top - 1, 10, (canvas.height / 240) * 67, "F");
                  top += (canvas.height / 240) * 70;
                  if (top > 208 && canvas !== last(pdfCanvas)) {
                    pdf.addPage("a4", "p");
                    top = this._addSummarytoPDF(segment, attributes, pdf) + 5;
                  }
                });
              }
              const map_els = document.getElementsByClassName(
                "google_map_container",
              );
              if (map_els.length > 0) {
                if (newPage) {
                  pdf.addPage("a4", "p");
                }
                top = this._addSummarytoPDF(segment, attributes, pdf) + 5;

                pdf.setFontSize(10);
                pdf.setFontType("normal");
                pdf.text(16, top, "GEOGRAPHY");
                top += 5;
                pdf.setDrawColor(128, 128, 128);
                pdf.line(16, top, 190, top);
                top += 5;

                html2canvas(map_els[0], {
                  useCORS: true,
                  allowTraint: true,
                  proxy: `${apiBaseUrl}/proxy/images`,
                }).then(
                  function(canva) {
                    pdf.addImage(canva.toDataURL(), "PNG", 30, 95);
                    setTimeout(
                      function() {
                        this.setState({ loaded: true });
                        var pageCount = pdf.internal.getNumberOfPages();
                        pdf.setFontSize(8);
                        pdf.setFontType("normal");
                        for (var i = 0; i < pageCount; i++) {
                          pdf.setPage(i);
                          pdf.text(
                            188,
                            288,
                            "Page " +
                              pdf.internal.getCurrentPageInfo().pageNumber +
                              " of " +
                              pageCount,
                            null,
                            null,
                            "right",
                          );
                          pdf.addImage(
                            pdfReportFooterDataUri(),
                            "PNG",
                            15,
                            290,
                            20,
                            0,
                          );

                          pdf.text(
                            65,
                            288,
                            "© " +
                              moment().format("YYYY") +
                              " Claritas, LLC. All rights reserved",
                          );
                        }
                        pdf.save(fileName);
                        this.setState({ showLoadingDialog: false });
                      }.bind(this),
                      4000,
                    );
                  }.bind(this),
                );

                top += 60;
                pdf.setDrawColor(128, 128, 128);
                pdf.line(16, top, 190, top);
                top += 5;
                pdf.text(16, top, "GEOGRAPHIC AREA SELECTED");
                const rawData = JSON.parse(segment.rawData);
                pdf.text(
                  186,
                  top,
                  splitNumber(rawData.plotted_values.audienceCount.total)(),
                  null,
                  null,
                  "right",
                );
              }

              if (geoDatas.length > 0) {
                if (newPage) {
                  pdf.addPage("a4", "p");
                }
                top = this._addSummarytoPDF(segment, attributes, pdf) + 5;

                pdf.setFontSize(10);
                pdf.setFontType("normal");
                pdf.text(16, top, "GEOGRAPHY");
                top += 8;

                const arrReplace = [];
                arrReplace.length = 0;
                const fillStrWidth = pdf.getStringUnitWidth(" _");

                let valStr = geoDatas[0] + splitNumber(segment.count)();
                for (
                  var i = 0;
                  i < (47 - pdf.getStringUnitWidth(valStr)) / fillStrWidth;
                  i++
                ) {
                  arrReplace.push(" _");
                }

                pdf.text(
                  185,
                  top,
                  geoDatas[0] +
                    arrReplace.join("") +
                    splitNumber(segment.count)(),
                  null,
                  null,
                  "right",
                );
                top += 7;

                valStr = geoDatas[1] + geoDatas[2];
                arrReplace.length = 0;
                for (
                  i = 0;
                  i < (47 - pdf.getStringUnitWidth(valStr)) / fillStrWidth;
                  i++
                ) {
                  arrReplace.push(" _");
                }
                pdf.text(
                  185,
                  top,
                  geoDatas[1] + arrReplace.join("") + geoDatas[2],
                  null,
                  null,
                  "right",
                );
                top += 5;
              }
              //setTimeout(function () {

              if (map_els.length <= 0) {
                setTimeout(
                  function() {
                    this.setState({ loaded: true });

                    var pageCount = pdf.internal.getNumberOfPages();
                    pdf.setFontSize(8);
                    pdf.setFontType("normal");
                    for (var i = 0; i < pageCount; i++) {
                      pdf.setPage(i);
                      pdf.text(
                        188,
                        288,
                        "Page " +
                          pdf.internal.getCurrentPageInfo().pageNumber +
                          " of " +
                          pageCount,
                        null,
                        null,
                        "right",
                      );
                      pdf.addImage(
                        pdfReportFooterDataUri(),
                        "PNG",
                        15,
                        290,
                        20,
                        0,
                      );
                      pdf.text(
                        65,
                        288,
                        "© " +
                          moment().format("YYYY") +
                          " Claritas, LLC. All rights reserved",
                      );
                    }
                    pdf.save(fileName);
                    this.setState({ showLoadingDialog: false });
                  }.bind(this),
                  4000,
                );
              }
            }.bind(this),
            1000,
          );
        }
      }.bind(this),
      50,
    );
  }

  _generateSelectData(segment_summary) {
    const datas = {};

    if (segment_summary && segment_summary.audiences) {
      map(segment_summary.audiences, audience => {
        let key = Object.keys(audience)[0];
        const val = Object.values(audience)[0];
        if (key.startsWith("a")) {
          key = parseInt(key.replace("a", ""), 10);
          if (key > 1 && key !== 3) {
            if (!datas[key])
              datas[key] = { total: val.total, label: val.label };
          }
        } else {
          if (key.startsWith("v")) {
            key = parseInt(key.replace("v", ""), 10);
            const attrObj = datas[val.attributeid];
            attrObj[key] = {
              total: val.total,
              label: val.label,
              email: val.email,
              social: val.social,
              display: val.display,
            };
          }
        }
      });
    }
    return datas;
  }

  _generateGeographyData(segment_summary) {
    const raw = JSON.parse(segment_summary.rawData);
    const result = [];
    if (!isEmpty(raw.plotted_values)) {
      const { radius, addressLabel, driveTime } = raw.plotted_values;

      if (addressLabel) {
        result[0] = addressLabel.replace(", United States", "");
        result[1] = driveTime ? "Drive from Location" : "Radius from Location";
        result[2] = driveTime ? driveTime + " hours" : radius + " miles";
      }
    }
    return result;
  }

  changeShowLoadingDialogState(obj) {
    this.setState(obj);
  }
  handleIconClick(targetValue) {
    this.props.handleIconClick(targetValue, this.state.activeIndex);
  }
  // handle the checkbox be selected
  handleCheckboxSelected(e, isInputChecked, itemId) {
    const itemIds = new Set([]);
    itemIds.add(itemId);
    this.setState({
      segmentsId: itemIds,
    });
    if (this.props.selectedSegment) this.props.selectedSegment([...itemIds]);
    if (this.props.checkBoxBeClick) this.props.checkBoxBeClick();
  }
  _gotoDetail(id) {
    this.props.clearSegmentSummary();
    this.props.history.push("detail/" + id);
  }

  formatNameTime(name) {
    if (typeof name !== "string") return name;
    const originNames = name.match(/.*_(\d+)$/);
    if (!originNames || !originNames[1] || originNames[1].length !== 8)
      return name;
    const originName = originNames[1];
    const year = originName.substr(0, 4);
    const month = originName.substr(4, 2);
    const day = originName.substr(6);
    return name.replace(originName, `${month}${day}${year}`);
  }

  // the end
  render() {
    const actions = [
      <FlatButton label="Close" primary={true} onTouchTap={this.handleClose} />,
    ];
    const muiTheme = getMuiTheme({
      checkbox: {
        checkedColor: buttonBlueColor(),
      },
    });
    const {
      tableHeaderArray,
      data,
      segment_summary,
      fetchSegmentDetail,
      segment_attributes,
      demoAttributes,
      geoAttributes,
    } = this.props;
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div
          className="segment-table"
          id="tbl-segments-list"
          onClick={e => this.handleClick(e)}
        >
          <Dialog
            open={this.state.showDataLoadingDialog}
            style={{ top: "-1.8em" }}
            overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
            modal={true}
          >
            <Row className="mt-20">
              <Col xs="7" sm="7" md="7" lg="7" className="text-right">
                <div>Data loading, please wait...</div>
              </Col>
              <Col xs="1" sm="1" md="1" lg="1">
                <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
              </Col>
            </Row>
          </Dialog>
          <Dialog
            open={this.state.openDetailDialog}
            onRequestClose={this.closeSegmentDetailDialog.bind(this)}
            modal={false}
            autoScrollBodyContent={true}
            style={{ top: "-1.8em" }}
            contentStyle={{ width: this.state.width + "px", maxWidth: "none" }}
            actions={[
              <a
                className="btn btn-default btn-xlg legitRipple bg-teal-400"
                style={{
                  marginRight: "56px",
                  marginTop: "1.5em",
                  marginBottom: "1.5em",
                }}
                onClick={this.closeSegmentDetailDialog.bind(this)}
              >
                Close
              </a>,
            ]}
          >
            <div
              key="segment-deatail-container"
              className="text-default no-padding pt-20 pl-20"
            >
              <Clear
                style={{
                  position: "absolute",
                  right: "2em",
                  cursor: "pointer",
                  top: "2.4em",
                }}
                onClick={() => this.closeSegmentDetailDialog()}
              />
              <SegmentSummary
                segment_id={this.state.detailSegmentId}
                segment_summary={segment_summary}
                segment_attributes={segment_attributes}
                demoAttributes={demoAttributes}
                geoAttributes={geoAttributes}
                popout={this.state.popout}
                popoutTip={() => this.popoutTip()}
                handleCancelArchive={() => this.handleCancelArchive()}
                showLoadingDialog={this.state.showLoadingDialog}
                archiveSegment={this.props.archiveSegment}
                updateSegmentList={this.props.updateSegmentList}
                handleActiveRedirectCreate={(id, clientId) =>
                  this.handleActiveRedirectCreate(id, clientId)
                }
                createCampaignPopover={(id, clientId) =>
                  this.createCampaignPopover(id, clientId)
                }
                fetchSegmentDetail={
                  fetchSegmentDetail ? fetchSegmentDetail : () => {}
                }
                changeShowLoadingDialogState={object =>
                  this.changeShowLoadingDialogState(object)
                }
                _generateSelectData={datas => this._generateSelectData(datas)}
                _handleDownloadPDF={() =>
                  this._handleDownloadPDF(
                    segment_summary,
                    segment_attributes,
                    demoAttributes,
                    geoAttributes,
                  )
                }
              />
            </div>
          </Dialog>

          {/*for create campaign component*/}
          <CreateCampaign
            openCreateCampaignDialog={this.state.openCreateCampaignDialog}
            closeCreateCampaignDialog={() => this.closeCreateCampaignDialog()}
            // ifShowEmailSubCheckbox={this.state.ifShowEmailSubCheckbox}
            // ifReturnEmailChecked={this.state.ifReturnEmailChecked}
            handleEmailChecked={(e, isInputChecked) =>
              this.handleEmailChecked(e, isInputChecked)
            }
            handleReturnEmail={(e, isInputChecked) =>
              this.handleReturnEmail(e, isInputChecked)
            }
            handleSocialMedia={(e, isInputChecked) =>
              this.handleSocialMedia(e, isInputChecked)
            }
            ifSocialMediaChecked={this.state.ifSocialMediaChecked}
            socialMediaFacebook={this.state.socialMediaFacebook}
            socialMediaGoogle={this.state.socialMediaGoogle}
            // handleSocialMediaAllChecked={() => this.handleSocialMediaAllChecked()}
            handleFacebookCheck={(e, isInputChecked) =>
              this.handleFacebookCheck(e, isInputChecked)
            }
            handleGoogleCheck={(e, isInputChecked) =>
              this.handleGoogleCheck(e, isInputChecked)
            }
            handleDisplayCheck={(e, isInputChecked) =>
              this.handleDisplayCheck(e, isInputChecked)
            }
            ifDisplayChecked={this.state.ifDisplayChecked}
            handleSelectAllCheckbox={() => this.handleSelectAllCheckbox()}
            createCampaign_segment_id={this.state.createCampaign_segment_id}
            getCreateCampaign={this.props.getCreateCampaign} // create campaign api function
            createCampaign_clientId={this.state.createCampaign_clientId}
            create_campaign={this.props.create_campaign}
            rollbackRequestSuccessToFalse={
              this.props.rollbackRequestSuccessToFalse
            }
          />
          {/*the end*/}

          <Table style={{ fontFamily: "Arial", fontsize: "16px" }}>
            <TableHeader
              displaySelectAll={false}
              style={styles.tableHeaderStyle}
              adjustForCheckbox={false}
            >
              <TableRow displayBorder={false} style={{ height: "30px" }}>
                {tableHeaderArray.length === 6
                  ? tableHeaderArray.map((header, index) => {
                      const isSortedCol =
                        this.props.sortName === header && header !== "";
                      if (index === 1) {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              width: "35%",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{ display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      } else if (index === 0) {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              width: "7%",
                              paddingRight: "10px",
                              textAlign: "center",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{ display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      } else if (index === 2) {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              textAlign: "left",
                              paddingRight: "64px",
                              width: "12%",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{ display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      } else if (index === 3) {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              textAlign: "left",
                              paddingRight: "64px",
                              width: "18%",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{ display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none', position: 'absolute', top: '1px' }} />*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      } else if (index === 4) {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              textAlign: "left",
                              paddingRight: "64px",
                              width: "13.5%",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{ display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none', position: 'absolute', top: '1px' }} />*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      } else {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{ display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none', position: 'absolute', top: '1px' }} />*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      }
                    })
                  : // for archive
                    tableHeaderArray.map((header, index) => {
                      const isSortedCol =
                        this.props.sortName === header && header !== "";

                      if (index === 0) {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              width: "8%",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{*/}
                            {/*display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none',*/}
                            {/*position: 'absolute',*/}
                            {/*top: '1px'*/}
                            {/*}}/>*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      } else if (index === 2) {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              textAlign: "left",
                              width: "14%",
                              paddingRight:
                                tableHeaderArray.length === 3 ? "96px" : "64px",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{ display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      } else {
                        return (
                          <TableHeaderColumn
                            key={index}
                            style={{
                              ...(isSortedCol
                                ? styles.tableHeaderSortedColumn
                                : styles.tableHeaderColumn),
                              width: index === 1 || index === 3 ? "33%" : "",
                            }}
                            className={"count-" + this.props.flag + index}
                          >
                            {header}
                            {/*<ArrowDown style={{*/}
                            {/*display: this.props.sortName !== header && (header !== "") ? 'inline-block' : 'none',*/}
                            {/*position: 'absolute',*/}
                            {/*top: '0.4em'*/}
                            {/*}}/>*/}
                            <ArrowDown
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "desc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                            <ArrowUp
                              onClick={() => this.handleIconClick(header)}
                              style={{
                                display:
                                  this.props.sort === "asc" &&
                                  this.props.sortName === header &&
                                  header !== ""
                                    ? "inline-block"
                                    : "none",
                                position: "absolute",
                                top: "10px",
                                right: "0",
                              }}
                            />
                          </TableHeaderColumn>
                        );
                      }
                    })}
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} className="archive-body">
              // for active
              {typeof data.data !== "undefined" &&
                this.props.flag === "active" &&
                data.data.map((item, index) => {
                  const _tableRow = (
                    <TableRow
                      key={index}
                      style={{
                        position: "relative",
                        borderBottom: "1px solid #E8EBEF",
                        height: "30px",
                      }}
                    >
                      {
                        <TableRowColumn style={{ width: "7%", height: "32px" }}>
                          {item.status === "Active" && (
                            <RadioButton
                              style={{
                                height: "28px",
                                transform: "scale(0.7)",
                              }}
                              // iconStyle={{width: '15px', height: '15px', marginTop: '3px'}}
                              checked={this.props.selectedSegmentSetArray.some(
                                id => id === item.id,
                              )}
                              onCheck={(e, selected) => {
                                this.handleCheckboxSelected(
                                  e,
                                  selected,
                                  item.id,
                                );
                              }}
                              value={item.id}
                            />
                          )}
                        </TableRowColumn>
                      }
                      <TableRowColumn
                        className="segment-row"
                        style={{ ...styles.tableRowColumn, width: "40%" }}
                      >
                        {item.status === "Pending" ? (
                          <span>{this.formatNameTime(item.name)}</span>
                        ) : (
                          <a
                            onClick={e => {
                              e.preventDefault();
                              this._gotoDetail(item.id);
                            }}
                          >
                            {this.formatNameTime(item.name)}
                          </a>
                        )}
                      </TableRowColumn>
                      {
                        <TableRowColumn
                          style={{ ...styles.tableRowColumn, width: "16%" }}
                        >
                          {item.createdTime}
                        </TableRowColumn>
                      }
                      {
                        <TableRowColumn
                          style={{ ...styles.tableRowColumn, width: "40%" }}
                        >
                          {item.sourceLabel}
                        </TableRowColumn>
                      }
                      {
                        <TableRowColumn
                          style={{ ...styles.tableRowColumn, width: "13.5%" }}
                        >
                          {item.status === "Active"
                            ? item.restoredTime
                              ? "Active from Archive"
                              : "Active"
                            : item.status}
                        </TableRowColumn>
                      }
                      {this.props.tableHeaderArray.some(
                        item => item === "CLIENT",
                      ) ? (
                        <TableRowColumn
                          style={{ position: "relative" }}
                          className=""
                        >
                          {item.clientName}
                          <Tooltip
                            placement="right"
                            overlayClassName="segment-list-tooltip"
                            overlay={
                              <NavList
                                roleName={this.props.roleName}
                                visible={!this.state.showLoadingDialog}
                                handleActiveRedirectCreate={() =>
                                  this.handleActiveRedirectCreate(
                                    item.id,
                                    item.clientId,
                                  )
                                }
                                popout={this.state.popout}
                                popoutTip={() => this.popoutTip()}
                                handleConfirmArchive={() =>
                                  this.handleConfirmArchive(item.id)
                                }
                                handleCancelArchive={() =>
                                  this.handleCancelArchive()
                                }
                                createCampaignPopover={() =>
                                  this.createCampaignPopover(
                                    item.id,
                                    item.clientId,
                                  )
                                }
                                _handleDownloadPDF={() =>
                                  this._handleDownloadPDF(
                                    segment_summary,
                                    segment_attributes,
                                    demoAttributes,
                                    geoAttributes,
                                  )
                                }
                              />
                            }
                            defaultVisible={false}
                            arrowContent={
                              <div className="rc-tooltip-arrow-inner" />
                            }
                          >
                            <Setting style={styles.settingStyle} />
                          </Tooltip>
                        </TableRowColumn>
                      ) : (
                        ""
                      )}
                    </TableRow>
                  );
                  const row = [
                    _tableRow,
                    <TableRow
                      className="archive-popout-tip"
                      style={{
                        height:
                          this.props.ifArchiveSuccess.some(
                            item => item === this.state.archivedId,
                          ) && item.id === this.state.archivedId
                            ? "30px"
                            : 0,
                        overflow: "hidden",
                        border: "none",
                      }}
                    >
                      <TableRowColumn
                        colSpan={
                          this.props.tableHeaderArray.some(
                            item => item === "CLIENT",
                          )
                            ? 4
                            : 6
                        }
                        className="clearfix"
                        style={{
                          height: 0,
                          overflow: "hidden",
                        }}
                      >
                        <span
                          style={{
                            display:
                              this.props.ifArchiveSuccess.some(
                                item => item === this.state.archivedId,
                              ) && item.id === this.state.archivedId
                                ? "inline"
                                : "none",
                          }}
                        >
                          This segment has been archived,
                        </span>
                        <a
                          href="/segments/list/archive"
                          style={{
                            display:
                              this.props.ifArchiveSuccess.some(
                                item => item === this.state.archivedId,
                              ) && item.id === this.state.archivedId
                                ? "inline"
                                : "none",
                          }}
                        >
                          View Archive
                        </a>
                      </TableRowColumn>
                    </TableRow>,
                  ];
                  return row;
                })}
              // for Archive
              {typeof data.data !== "undefined" &&
                this.props.flag === "archive" &&
                data.data.map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      borderBottom: "1px solid #E8EBEF",
                      height: "30px",
                    }}
                  >
                    <TableRowColumn style={{ width: "6%", height: "32px", padding: 0, textAlign: 'center' }}>
                      <RadioButton
                        style={{ height: "28px", transform: "scale(0.7)" }}
                        checked={
                          this.state.segmentsId.values().next().value &&
                          this.state.segmentsId.values().next().value ===
                            item.id
                        }
                        onCheck={(e, selected) => {
                          this.handleCheckboxSelected(e, selected, item.id);
                        }}
                        value={item.id}
                      />
                    </TableRowColumn>
                    <TableRowColumn
                      style={{ ...styles.tableRowColumn, width: "25%", padding: 0 }}
                    >
                      <a onClick={() => this.copySegment(item.id)}>
                        {item.name}
                      </a>
                    </TableRowColumn>
                    <TableRowColumn
                      style={{ ...styles.tableRowColumn, width: "9%", padding: 0, textAlign: 'center' }}
                    >
                      {item.archivedTime}
                    </TableRowColumn>
                    <TableRowColumn
                      style={{ ...styles.tableRowColumn, width: "25%" }}
                    >
                      {item.sourceLabel}
                    </TableRowColumn>
                    <TableRowColumn
                      style={{ ...styles.tableRowColumn, width: "8.6%" }}
                    >
                      {item.status}
                    </TableRowColumn>

                    {this.props.tableHeaderArray.some(
                      item => item === "CLIENT",
                    ) ? (
                      <TableRowColumn style={styles.tableRowColumn}>
                        {item.clientName}
                      </TableRowColumn>
                    ) : (
                      ""
                    )}

                    {/*<TableRowColumn style={styles.tableRowColumn}>*/}
                    {/*{item.createdTime}*/}
                    {/*<Tooltip*/}
                    {/*placement="right"*/}
                    {/*overlay={*/}
                    {/*this.props.flag === 'active' ?*/}
                    {/*"" :*/}
                    {/*<ul style={{ margin: 0, padding: 0 }}>*/}
                    {/*<li style={{ listStyleType: 'none', paddingTop: 0 }} className="clearfix">*/}
                    {/*<Reply*/}
                    {/*style={{ float: 'left', width: '16px', height: '16px', marginRight: '0.6em', WebkitTransform: 'rotateY(180deg)' }}*/}
                    {/*/>*/}
                    {/*<a style={{ width: '9em', color: '#0997F7', float: 'left', lineHeight: '1.3em' }} onClick={(e) => this.handleCopyToCreate(e, item.id, item.clientId, item.name)}>Copy this segment</a>*/}
                    {/*</li>*/}
                    {/*</ul>*/}
                    {/*}*/}
                    {/*defaultVisible={false}*/}
                    {/*arrowContent={<div className="rc-tooltip-arrow-inner"></div>}*/}
                    {/*>*/}
                    {/*<Setting style={styles.settingStyle} />*/}
                    {/*</Tooltip>*/}
                    {/*</TableRowColumn>*/}
                  </TableRow>
                ))}
            </TableBody>
          </Table>

          <Page
            nextBeClick={page => this.goToNext(page)}
            pageCount={data.pageCount}
            pageSize={data.pageSize}
            nextGroupBeClick={page => this.nextToGroup(page)}
            previousGroupBeClick={page => this.previousToGroup(page)}
            previousBeClick={page => this.goToPrevious(page)}
            pageBeClick={page => this.pageBeClick(page)}
            total={data.total}
            hasNext={data.hasNext}
            hasPrevious={data.hasPrevious}
            pagePlus={true}
            selectRows={(page, row) => this.selectRows(page, row)}
            goToPage={page => this.goToPage(page)}
            segmentIds={this.state.segmentsId}
            archiveFun={
              this.props.flag === "archive"
                ? null
                : () => {
                    this.props.handleConfirmArchive();
                  }
            }
            unArchiveFun={
              this.props.flag === "archive"
                ? id => {
                    this.props.reactiveSegment(id);
                  }
                : null
            }
            editFun={
              this.props.flag === "archive" ? null : id => this.handleEdit(id)
            }
            reactive_success={this.props.reactive_success}
            reactive_on_progress={this.props.reactive_on_progress}
            history={this.props.history}
          />
          <Dialog
            title=""
            contentStyle={{ width: "80%", maxWidth: "inherit" }}
            actions={actions}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
          >
            <div className="top-copy-archive clearfix">
              <span>{this.state.archive_data_obj.name}</span>
              {/*
              <Tooltip
                placement="right"
                overlay={
                  <div style={{ padding: '0.6em' }} className="clearfix">
                    <ContentCopy style={{ float: 'left' }} />
                    <a style={{ float: 'left', marginTop: '0.4em', marginLeft: '0.3em' }} onClick={(e) => this.handleCopyToCreate(e, this.state.archive_data_obj.id, this.state.archive_data_obj.clientId,
                       this.state.archive_data_obj.name)}>Copy this segment</a>
                  </div>
                }
                defaultVisible={false}
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
              >
                <Setting style={{ float: 'left' }} />
              </Tooltip>*/}
            </div>
            <ul className="copy-archive-ul clearfix">
              <li className="clearfix">
                <span>Date</span>
                <strong>
                  <em>{this.state.archive_data_obj.archivedTime}</em>
                </strong>
              </li>
              <li>
                <span>Attributes</span>
                <strong>
                  <em>{this.props.segment_attributes}</em>
                </strong>
              </li>
              <li className="clearfix">
                <span>Client</span>
                <strong>
                  <em>{this.state.archive_data_obj.clientName}</em>
                </strong>
              </li>
              <li>
                <span>Count</span>
                <strong>
                  <em>{this.state.archive_data_obj.count}</em>
                </strong>
              </li>
            </ul>
          </Dialog>
        </div>
      </MuiThemeProvider>
    );
  }
}

SegmentTable.propTypes = {
  tableHeaderArray: PropTypes.array,
  data: PropTypes.object,
  headerBeClick: PropTypes.func,
  pageBeClick: PropTypes.func,
  nextBeClick: PropTypes.func,
  previousBeClick: PropTypes.func,
  nextGroupBeClick: PropTypes.func,
  previousGroupBeClick: PropTypes.func,
  sort: PropTypes.string,
  sortName: PropTypes.string,
  ifArchiveSuccess: PropTypes.array,
  getAttributes: PropTypes.func,
  copySegmentRedirect: PropTypes.func,
  selectedClientChanged: PropTypes.func,
  flag: PropTypes.string,
};

export default SegmentTable;



// WEBPACK FOOTER //
// ./src/components/Segment/List/Table.jsx